<div class="bg-white rounded-lg border border-gray-200 p-8">
  <h1 class="text-2xl font-bold text-[#3abfad] mb-6">
    2. Validación de identidad <span class="text-gray-600 font-normal">(2 de 2)</span>
  </h1>

  <div class="flex flex-col items-center text-center mb-10">
    <h2 class="text-xl font-semibold text-gray-700 mb-6">{{ userName }}</h2>
    <p class="text-gray-600 max-w-2xl">
      Para garantizar que solo tú puedas realizar esta validación, te solicitaremos confirmar tu identidad mediante
      reconocimiento facial a través de tu celular.
    </p>
  </div>

  <div class="flex flex-col md:flex-row items-center justify-center gap-10 mb-10">
    <!-- QR Code -->
    <div class="flex-shrink-0">
      <img
        src="/qr-code.png"
        alt="Código QR para validación"
        width="180"
        height="180"
        class="border border-gray-200 p-2 rounded-md"
      />
    </div>

    <div class="flex flex-col">
      <h3 class="text-lg font-medium text-gray-700 mb-4">Escanea desde tu celular el código QR</h3>

      <div class="bg-gray-50 border border-gray-200 rounded-md p-4 mb-4">
        <p class="font-medium text-gray-700 mb-2">Una vez hayas ingresado, necesitarás</p>
        <ul class="space-y-1 text-gray-600">
          <li class="flex items-start">
            <span class="mr-2">•</span>
            <span>Tu cédula de identidad vigente.</span>
          </li>
          <li class="flex items-start">
            <span class="mr-2">•</span>
            <span>Tu cámara frontal y micrófono funcionando.</span>
          </li>
          <li class="flex items-start">
            <span class="mr-2">•</span>
            <span>Un lugar con buena luz y señal de wifi</span>
          </li>
        </ul>
      </div>

      <a href="#" class="text-[#3abfad] hover:underline flex items-center text-sm">
        Conoce más sobre el proceso de validación
        <span class="ml-1 h-3 w-3">→</span>
      </a>
    </div>
  </div>

  <div class="bg-[#e6f7f5] border-[#3abfad] my-10 p-4 rounded-md">
    <div class="flex">
      <span class="h-5 w-5 text-[#3abfad] mr-2">ℹ️</span>
      <div class="text-gray-700">
        <p class="font-semibold">¡No cierres esta ventana!</p>
        <p>Al completar la verificación biométrica, podrás continuar automáticamente desde este navegador.</p>
      </div>
    </div>
  </div>

  <p class="text-center text-gray-600 text-sm">
    Recuerda que tu información facial <span class="font-semibold">no será almacenada</span> ni utilizada para
    ningún otro propósito.
  </p>
</div> 